import React from 'react';
import { useHistory } from 'react-router-dom';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import Menu from '../../../../../components/common/Menu';
import AppCard from '../../../../../components/ui/AppCard';
import InfoField from '../../../../../components/ui/InfoField';
import StatusBadge from '../../../../../components/ui/StatusBadge';
import StorageHelper from '../../../../../utils/storage-helper';
import AdvertisementGallery from '../../../../dashboard/components/AdvertisementGallery';
import { getPolicyStatusLabel, getPolicyStatusTone, getPolicyStatusMessage } from '../../../../policies/utils/policyStatus';
import { policyMenuTrigger } from '../../../../policies/components/policyMenuTrigger';
import localBGImage from '../../../../../assets/images/patterns/applyPolicy.png';

export default function EasipolPolicyDisplay({ policyList, policyDisplayKey, updateSelectedPolicy, apiResponse }) {
  const history = useHistory();
  const currentPolicy = policyList?.[policyDisplayKey];
  const currentMember = currentPolicy?.MainMember;

  const statusLabel = getPolicyStatusLabel(currentMember?.Status);
  const statusTone = getPolicyStatusTone(currentMember?.Status);
  const statusMessage = getPolicyStatusMessage(currentMember);

  const viewPolicyStatement = (selectedPolicyOBJ) => {
    StorageHelper.set("policyId", selectedPolicyOBJ.MainMember.Policy_Number);
    history.push("/payments");
  };

  return (
    <>
      {policyList ? (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          <div className="relative bg-base-300/40 rounded-2xl overflow-hidden w-full h-full min-h-[400px]">
            <AdvertisementGallery />
          </div>

          <div>
            <AppCard headerImg={localBGImage}>
              <div className="mb-4">
                <span className="badge badge-info bg-blue-100 text-blue-700 border-none badge-sm uppercase font-bold mb-3 px-3 py-3 rounded-full tracking-wider text-xs">Policy Summary</span>
                <h2 className="text-2xl font-extrabold text-base-content mb-2 tracking-tight">Your Policy Details</h2>
                <p className="text-sm text-base-content/70">Review the selected policy and member information.</p>
              </div>
              <Divider type="solid" className="opacity-30 my-4" />

              <div className="mb-6">
                <Menu
                  className="dl-policy-menu border border-base-300 rounded-xl px-4 py-3 w-full bg-base-100 flex justify-between items-center cursor-pointer shadow-sm"
                  trigger={policyMenuTrigger(currentMember.Policy_Number)}
                  items={policyList}
                  getKey={(p) => p.MainMember.Policy_Number}
                  searchable={policyList.length > 5}
                  searchPlaceholder="Search policy number"
                  filterItem={(p, q) =>
                    p.MainMember.Policy_Number.toLowerCase().includes(q.toLowerCase())
                  }
                  renderItem={(p) => (
                    <span className="flex justify-between items-center w-full py-2 border-b border-base-200 last:border-0">
                      <span className="font-semibold text-base-content">
                        {p.MainMember.Policy_Number}
                      </span>
                    </span>
                  )}
                  onChange={(p) => updateSelectedPolicy(p, policyList, apiResponse)}
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                <InfoField label="Monthly Premium" value={`$ ${currentMember.UsualPremium ?? "N/A"}`} />
                <InfoField 
                  label="Policy Status" 
                  value={<StatusBadge tone={statusTone} label={statusLabel} message={statusMessage} />} 
                />
                <InfoField label="Policy Number" value={currentMember.Policy_Number} />
                <InfoField label="Policy Product" value={currentMember.Product_Name} />
              </div>

              <div className="mt-6 flex flex-row flex-wrap gap-3">
                <Button
                  className="flex-1 font-bold btn btn-ghost"
                  size="large"
                  label="View Policy Details"
                  severity="info"
                  rounded
                  outlined
                  onClick={() => history.push("/manage-policy")}
                />
                <Button
                  className="flex-1 font-bold btn btn-primary"
                  size="large"
                  label="Make Payment"
                  severity="info"
                  rounded
                  raised
                  onClick={() => {
                    viewPolicyStatement(currentPolicy);
                  }}
                />
              </div>
            </AppCard>
          </div>
        </div>
      ) : (
        <div className="p-4 bg-error text-error-content rounded-xl">No policy available</div>
      )}
    </>
  );
}
